import React from "react";
import CountUp from "react-countup";

const FunfactSection = () => {
  return (
    <section className="fanfact pt-85 pb-125">
      <div className="container">
        <div className="row mt-none-30">

          {/* GLOBAL DELEGATES */}
          <div className="col-lg-4 col-md-4 mt-30">
            <div
              className="ap-fanfact-item wow fadeInUp"
              data-wow-delay="0ms"
              data-wow-duration="600ms"
            >
              <h2 className="xb-item--number">
                <CountUp end={500} enableScrollSpy />+
              </h2>
              <span className="xb-item--text">
                Expected Global Delegates
              </span>
            </div>
          </div>

          {/* SPEAKERS */}
          <div className="col-lg-4 col-md-4 mt-30">
            <div
              className="ap-fanfact-item ap-fanfact-item--middle wow fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="600ms"
            >
              <h2 className="xb-item--number">
                <CountUp end={35} enableScrollSpy />+
              </h2>
              <span className="xb-item--text">
                Visionary Speakers & Panelists
              </span>
            </div>
          </div>

          {/* PARTNERS */}
          <div className="col-lg-4 col-md-4 mt-30">
            <div
              className="ap-fanfact-item ap-fanfact-item--last wow fadeInUp"
              data-wow-delay="300ms"
              data-wow-duration="600ms"
            >
              <h2 className="xb-item--number">
                <CountUp end={25} enableScrollSpy />+
              </h2>
              <span className="xb-item--text">
                Supporting Partners & Sponsors
              </span>
            </div>
          </div>

        </div>
      </div>

      {/* REQUIRED FOR COUNTUP SCROLL SPY */}
      <span id="counter" className="d-none" />
    </section>
  );
};

export default FunfactSection;
